

import { Routes } from '@angular/router';
import { MycalendarComponent } from './mycalendar/mycalendar.component';
import { GoogleloginComponent } from './googlelogin/googlelogin.component';


export const CalendarRoutes: Routes = [{ 
  path: '',
  component: MycalendarComponent
},
{ 
  path: 'mycalendar',
  component: MycalendarComponent
},
{ 
  path: 'googlelogin',
  component: GoogleloginComponent
}];

